import { Component, OnInit } from '@angular/core';
import { GlobalService } from './global.service';
import { Router, NavigationStart, NavigationEnd, Event, NavigationError } from '@angular/router';
import { TranslateService } from './Services/translate.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalService } from './Services/local.service';
import { ToastrService } from 'ngx-toastr';
import { BnNgIdleService } from 'bn-ng-idle';
import { QuoteService } from './Modules/motor/Modules/quote/Services/quote.service';
import { global } from '@angular/compiler/src/util';
import { locale } from 'moment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'NICB2BUI';
  constructor(public global: GlobalService, private router: Router, private translateService: TranslateService, private spinner: NgxSpinnerService, private toastr: ToastrService,
    private local: LocalService, private bnIdle: BnNgIdleService, private quoteService: QuoteService
  ) {


    this.bnIdle.startWatching(1500).subscribe((res) => {
       
      if (res) {
        this.toastr.info("Session has been expired.Kindly Re Login ", undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 10000
        });
        this.router.navigate(["/home"]);
        sessionStorage.remove();
      }

      //to unlock the QQ

      var unlock = sessionStorage.getItem('LOCK');
      if (unlock == "L") {

        var userName = sessionStorage.getItem('userName');
        this.quoteService.unlockQuotedetails(userName).subscribe((data: any) => {

        })
      }
      //END
      //TO DELETE THE POLICY DETAILS UNDER STANDALONE receipting
      var Stdreceipting = sessionStorage.getItem('StandaloneDel');
      if (Stdreceipting == "DeletePolDtls") {
        
        var RHsysid = sessionStorage.getItem('RHSYSID');
        this.quoteService.deleteStdPolicyDtls(RHsysid).subscribe((data: any) => {
          
          console.log(data.responseBody.Validation);
          if (data.responseBody.Validation == "PolicyDtlsremoved") {
            sessionStorage.removeItem("StandaloneDel");
            sessionStorage.removeItem("RHSYSID");
          }
        })
      }
      //END

    })
    //show the progressbar in globally//
    // this.global.showProgress.subscribe((data: string) => {
    //   

    // var flag=data.split("/");
    // var spinnerFlag=flag[0];
    // var errorFlag=flag[1];
    // if(errorFlag=="ET"){
    //   this.spinner.hide();
    //     this.toastr.error(this.global.errorMessage, undefined, {
    //             positionClass: 'toast-bottom-right',
    //             timeOut: 6000
    //        });
    // }
    //   if (spinnerFlag=="ST") {
    //     
    //     this.spinner.show();
    //   } else {
    //     
    //     this.spinner.hide();

    //   }
    // });

    this.global.showProgress.subscribe((data: boolean) => {



      if (data) {
        this.spinner.show();
        // this.toastr.error(this.global.errorMessage, undefined, {
        //         positionClass: 'toast-bottom-right',
        //         timeOut: 6000
        //    });
      }
      else {

        this.spinner.hide();

      }
    });

    //show the Messages in globally//
    this.global.messageEmitter.subscribe((errorMsg: string) => {

      // if(errorFlag){

      // }
      if (errorMsg != undefined) {

        this.spinner.hide();
        this.toastr.error(errorMsg, undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 6000
        });
      } else {

        this.spinner.hide();
      }
    }); 

    if (this.global.quoteNoForDMS == undefined) {
      this.global.quoteNoForDMS = this.local.getString("QuoteNo");
    }

    this.router.events.subscribe((event: Event) => {

      if (event instanceof NavigationStart) {
        //this.previousUrl = this.router.url;

        if (event.url.includes("/home") || event.url.includes("/privacypolicy") || event.url.includes("/termsandconditions") || event.url.includes("/contactus") || event.url.includes("/paymentresponse")) {
          this.global.showWhiteBanner = true;
        } else {
          if (event.url.length <= 1) {
            this.global.showWhiteBanner = true;
          } else {
            this.global.showWhiteBanner = false;
          }
        }
        this.global.loadPageContent(event.url)

      }

      if (event instanceof NavigationEnd) {
        //this.currentUrl = event.url;
      }

      if (event instanceof NavigationError) {
      }
    });
  }
  ngOnInit() { 
if(sessionStorage.getItem('token') == undefined || sessionStorage.getItem('token') == "" || sessionStorage.getItem('token') == ''){
      sessionStorage.clear();
      global.clear(); 
      this.router.navigate(["home"]);
} 
    // if (this.global.username == undefined || this.global.username == "" ||this.global.username == '') {
    //   sessionStorage.clear();
    //   this.router.navigate(["home"]);
    //      }
    /** spinner starts on init */
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 2000);
  }
}
